import React from "react";

const PendingCardBadges = ({ isUrgent, needsMyApproval }) => {
  if (!isUrgent && !needsMyApproval) return null;

  const label = isUrgent ? "Khẩn cấp" : "Cần duyệt";
  const tone = isUrgent
    ? "bg-orange-500 shadow-orange-200/80"
    : "bg-red-600 shadow-red-200/80";

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-2xl z-[2]">
      <span
        className={`absolute top-[18px] -right-[34px] w-[128px] py-1 text-center text-[8px] font-black uppercase tracking-[0.14em] text-white shadow-sm ${tone}`}
        style={{ transform: "rotate(40deg)" }}
      >
        {label}
      </span>
    </div>
  );
};

export default PendingCardBadges;
